<style>
#video{
  width:100vw;
  max-width:1400px;
}
@media screen and (max-width: 960px) {
    #customize {
        display: none;
    }
}
</style>

<template>

<div class="pt-24 lg:pt-32 mx-auto">

      <video controls ref="sixvideo" id="video" preload="none" poster="/images/video-poster.jpg" :disabled="isPlaying" @click="play">
        <source src="/videos/six-032221-1080.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>

      <div class="flex justify-center mt-8 mb-16">
      <a href="https://thesix56.com/gallery" class="button mx-2" >View Gallery</a>
      <a href="https://customize.thesix56.com/floors" class="button mx-2" id="customize">Customize Layout</a>
    </div>

</div>

</template>

<script>

export default {
    name: 'home',


    data() {
        return {
            isPlaying: false
        }
    },

    methods: {
        play() {
          this.$refs.sixvideo.play()
          this.isPlaying = true
        },
        stop() {
          this.$refs.sixvideo.pause()
          this.isPlaying = false
        }
    }
}

</script>
